import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useUpsertCleanRoom = (crId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const queryClient = useQueryClient();

  return useMutation(
    (data) => axiosInstance.put(cleanRoom(orgId)
      .upsertCleanRoom, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['CleanRoom', orgId, crId]);
        dispatch(showAlert({
          message: 'Cleanroom config created/updated successfully!',
          type: 'success',
        }));
      },
      onError: () => {
        dispatch(showAlert({
          message: 'Error in creating/updating cleanroom config',
          type: 'error',
        }));
      },
    },
  );
};
